/**
 * Selection of `ServiceReport` (tab Service), shared by the page fragment and the block
 * project-service-report-data, so both read the same fields.
 */
export const SERVICE_REPORT_SELECTION = `
  completed {
    type
    value
  }
  brickAndUkAssemblyType
  brickAndUkA2State
  brickAndUkBState
  railsEarthed
  brickAndUkOptionalNotes
  cableManagementC2State
  cableManagementOptionalNotes
  hakLocationState
  hakLockedState
  hakToZsDistance
  hakAndZsSameRoomState
  zsLocationState
  additionalSubDistributionState
  electricMeterCount
  electricMeterList
  intermediateMeterRequestedState
  meterCombinationRequestedState
  disassembledMetersOnSiteState
  meterCascadeRequestedState
  installationLocationWithInverterAndMateboxState
  distanceMeasurement
  stringPlanAvailableState
  cablePathDistance
  cableSelection
  equipotentialBusBarPresentState
  secondaryEquipotentialBusBarPresentState
  potentialGroundRodPresentState
  earthingSupply16mmState
  internetConnectionTypeState
  lanConnectionPresentState
  qcellsWallboxContractState
  briefingAndDocumentationState
  solarPaneldOptionalNotes
  serviceOptionalNotes
`;
